import { render, staticRenderFns } from "./Geolocalizzazione.vue?vue&type=template&id=5203351a&scoped=true&"
import script from "./Geolocalizzazione.vue?vue&type=script&lang=js&"
export * from "./Geolocalizzazione.vue?vue&type=script&lang=js&"
import style0 from "./Geolocalizzazione.vue?vue&type=style&index=0&id=5203351a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5203351a",
  null
  
)

export default component.exports